module.exports = __webpack_public_path__ + "dash_20_app_assets/img/thankyou.64803f2e.png";